<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab ripple>Utilisateurs</v-tab>
	</v-tabs>
	<user-list ref="userList" :url="'users?filter=bots.bot:$eq:'+$route.params.botId" :list-actions="importUsers">
	</user-list>
</div>
</template>

<script>
import UserList from '../../components/users/user.list'
import { SUCCESS, SET_BOT} from '../../variables'

export default {
	data() {
		return {
			importUsers: [{
				name: 'Importer',
				function: async (filterString) => {
					let input = document.createElement('input')

					input.onchange = event => {
						let formData = new FormData()
						formData.append('file', event.target.files[0])

						this.axios
							.post('users/' + this.$route.params.botId + '/import', formData, {
								headers: {
									'content-type': 'multipart/form-data'
								}
							})
							.then(response => {
								this.$store.dispatch(SUCCESS, 'Utilisateurs importés')

								// this is to update list and group
								this.$store.dispatch(SET_BOT, this.$route.params.botId)
									.then(() => {
										this.$refs.userList.update()
									})
							})
							.catch((err) => { console.log(err) })
					}

					input.type = 'file'
					input.click()
				}
			}]
		}
	},
	components: { UserList }
}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/user.list.vue